import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FC } from 'react'
import { SimplePlanOptionsSectionData } from '../types'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import CTAButton from './CTAButton'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'
import SimplePlanOption from './SimplePlanOption'

//sectionId is used for navigation
const SimplePlanOptionsSection: FC<{
  data?: SimplePlanOptionsSectionData
  sectionId: string
}> = ({ data, sectionId }) => {
  if (!data) return null

  return (
    <Box display="block" maxWidth="948px" mx="auto" id={sectionId}>
      <PrismicText
        richTextField={data.primary?.header}
        variant="display/large"
        fontSize={{ _: '24px', md: '28px', lg: '32px' }}
        px="50px"
        textAlign="center"
        lineHeight={{ _: '30px', lg: '40px' }}
      />
      <Spacer mb="52px" />
      <Box
        display="grid"
        gridTemplateColumns={{ _: '1fr', md: `repeat(${data.items?.length}, 1fr)` }}
        justifyItems="center"
      >
        {data.items?.map((item, idx) => (
          <SimplePlanOption data={item} key={idx} />
        ))}
      </Box>
      <Spacer mb={{ _: '0px', md: '52px' }} />
      <Box flexDirection="column" alignItems="center">
        <CTAButton
          label={data.primary?.button_label}
          href={data.primary?.button_href?.url}
          variant={data.primary?.button_variant}
        />
      </Box>
      <Spacer mb={{ _: '32px', md: '56px', lg: '96px' }} />
    </Box>
  )
}

export default SimplePlanOptionsSection
